var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationMarkerFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    fill: "none",
    viewBox: "0 0 14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE741F",
    d: "M7 0C3.134 0 0 3.134 0 7c0 3.957 4.384 10.357 6.213 12.62.406.501 1.168.501 1.574 0C9.617 17.356 14 10.956 14 7c0-3.866-3.134-7-7-7zm0 4.5c1.381 0 2.5 1.119 2.5 2.5S8.381 9.5 7 9.5 4.5 8.381 4.5 7 5.619 4.5 7 4.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerFilled);
export default __webpack_public_path__ + "static/media/location-marker-filled.aa6dcc63655d1db323279ef523b79ce0.svg";
export { ForwardRef as ReactComponent };